import { render, staticRenderFns } from "./TranscriptViewer.vue?vue&type=template&id=01f5459c"
import script from "./TranscriptViewer.vue?vue&type=script&lang=js"
export * from "./TranscriptViewer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports